/* Atelier Marta — refonte 2026
   Tiroir panier sur l'API Cart de Shopify, galerie produit, filtres boutique, menu mobile.
   Aucune dependance externe. */

(function () {
  'use strict';

  var racines = window.routes || {};
  var URL_CART = '/cart.js';
  var URL_ADD = racines.cart_add_url ? racines.cart_add_url + '.js' : '/cart/add.js';
  var URL_CHANGE = racines.cart_change_url ? racines.cart_change_url + '.js' : '/cart/change.js';

  var config = window.MARTA_CONFIG || {};
  var franco = Number(config.franco || 0);           // en centimes
  var suggestions = config.suggestions || [];
  var devise = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  var formateur;
  try {
    formateur = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: devise });
  } catch (e) {
    formateur = null;
  }

  function euro(centimes) {
    var v = (Number(centimes) || 0) / 100;
    if (formateur) return formateur.format(v);
    return v.toFixed(2).replace('.', ',') + ' €';
  }

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function echappe(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------------ panier */

  var tiroir, voile, etatPanier = null, enCours = false;

  function ouvrirTiroir() {
    if (!tiroir) return;
    tiroir.classList.add('ouvert');
    tiroir.setAttribute('aria-hidden', 'false');
    if (voile) voile.classList.add('visible');
    document.body.style.overflow = 'hidden';
    var f = $('.mrt-drawer-fermer', tiroir);
    if (f) f.focus();
  }

  function fermerTiroir() {
    if (!tiroir) return;
    tiroir.classList.remove('ouvert');
    tiroir.setAttribute('aria-hidden', 'true');
    if (voile) voile.classList.remove('visible');
    document.body.style.overflow = '';
  }

  function chargerPanier() {
    return fetch(URL_CART, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { etatPanier = c; rendre(); return c; });
  }

  function ajouter(variantId, quantite, bouton) {
    if (enCours) return Promise.resolve();
    enCours = true;
    if (bouton) bouton.setAttribute('aria-busy', 'true');
    if (tiroir) tiroir.classList.add('mrt-occupe');
    return fetch(URL_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Number(quantite) || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return chargerPanier(); })
      .then(function () { ouvrirTiroir(); })
      .catch(function () { window.location.href = '/cart'; })
      .then(function () {
        enCours = false;
        if (bouton) bouton.removeAttribute('aria-busy');
        if (tiroir) tiroir.classList.remove('mrt-occupe');
      });
  }

  function changerLigne(cle, quantite) {
    if (enCours) return;
    enCours = true;
    if (tiroir) tiroir.classList.add('mrt-occupe');
    fetch(URL_CHANGE, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: Number(quantite) })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { etatPanier = c; rendre(); })
      .catch(function () {})
      .then(function () {
        enCours = false;
        if (tiroir) tiroir.classList.remove('mrt-occupe');
      });
  }

  function suggestionsRestantes() {
    if (!etatPanier) return [];
    var dedans = (etatPanier.items || []).map(function (i) { return String(i.product_id); });
    return suggestions.filter(function (s) {
      return dedans.indexOf(String(s.produit)) === -1 && s.variante;
    }).slice(0, 6);
  }

  function htmlSuggestions() {
    return suggestionsRestantes().map(function (s) {
      return '<div class="mrt-sug">' +
        (s.image ? '<img src="' + echappe(s.image) + '" alt="" width="120" height="120">' : '') +
        '<div><p class="mrt-sug-nom">' + echappe(s.titre) + '</p>' +
        (s.accroche ? '<p class="mrt-sug-acc">' + echappe(s.accroche) + '</p>' : '') + '</div>' +
        '<button type="button" class="mrt-sug-btn" data-mrt-ajout="' + echappe(s.variante) + '">' +
        'Ajouter ' + euro(s.prix) + '</button>' +
        '</div>';
    }).join('');
  }

  function rendre() {
    if (!etatPanier) return;

    var total = etatPanier.total_price || 0;
    var nb = etatPanier.item_count || 0;

    $$('.mrt-compteur').forEach(function (e) {
      e.textContent = nb;
      e.hidden = nb === 0;
    });

    if (!tiroir) return;

    var reste = Math.max(0, franco - total);
    var pct = franco > 0 ? Math.min(100, (total / franco) * 100) : 100;

    var barre = $('.mrt-jauge-barre', tiroir);
    var msg = $('.mrt-jauge-message', tiroir);
    if (barre) {
      barre.style.width = pct + '%';
      barre.classList.toggle('atteint', reste === 0);
    }
    if (msg) {
      msg.innerHTML = reste === 0
        ? '<strong>Livraison offerte débloquée</strong>'
        : 'Plus que <strong>' + euro(reste) + '</strong> pour la livraison offerte';
    }

    var corps = $('.mrt-drawer-lignes', tiroir);
    if (corps) {
      if (nb === 0) {
        corps.innerHTML = '<p class="mrt-drawer-vide">Votre panier est vide.</p>';
      } else {
        corps.innerHTML = (etatPanier.items || []).map(function (l) {
          var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
          var variante = (l.variant_title && l.variant_title !== 'Default Title') ? l.variant_title : '';
          return '<div class="mrt-ligne">' +
            (img ? '<img src="' + echappe(img) + '" alt="" width="76" height="76">' : '<span></span>') +
            '<div><p class="mrt-ligne-nom"><a href="' + echappe(l.url) + '">' + echappe(String(l.product_title).split('|')[0].trim()) + '</a></p>' +
            (variante ? '<p class="mrt-ligne-variante">' + echappe(variante) + '</p>' : '') +
            '<p class="mrt-ligne-prix">' + euro(l.final_price) + '</p>' +
            '<div class="mrt-qte">' +
            '<button type="button" aria-label="Retirer un ' + echappe(l.product_title) + '" data-mrt-moins="' + echappe(l.key) + '" data-mrt-qte="' + (l.quantity - 1) + '">−</button>' +
            '<span>' + l.quantity + '</span>' +
            '<button type="button" aria-label="Ajouter un ' + echappe(l.product_title) + '" data-mrt-plus="' + echappe(l.key) + '" data-mrt-qte="' + (l.quantity + 1) + '">+</button>' +
            '</div></div>' +
            '<p class="mrt-ligne-total">' + euro(l.final_line_price) + '</p>' +
            '</div>';
        }).join('');
      }
    }

    var sugs = htmlSuggestions();
    var aDesSug = sugs !== '' && nb > 0;
    tiroir.classList.toggle('a-suggestions', aDesSug);

    var ext = $('.mrt-drawer-extension', tiroir);
    if (ext) ext.innerHTML = aDesSug ? '<p class="mrt-sug-titre">Souvent ajouté avec</p>' + sugs : '';
    var extMob = $('.mrt-sug-mobile', tiroir);
    if (extMob) extMob.innerHTML = aDesSug ? '<p class="mrt-sug-titre">Souvent ajouté avec</p>' + sugs : '';

    var tot = $('.mrt-drawer-total', tiroir);
    if (tot) tot.textContent = euro(total);
    var liv = $('.mrt-drawer-livraison', tiroir);
    if (liv) liv.textContent = reste === 0 ? 'Offerte en point relais' : 'Calculée au paiement';
    var bouton = $('.mrt-drawer-commander', tiroir);
    if (bouton) bouton.disabled = nb === 0;
  }

  /* ------------------------------------------------------------ galerie produit */

  function choisirVignette(v) {
    var principale = $('.mrt-produit-principale');
    if (principale) {
      principale.src = v.getAttribute('data-mrt-vignette');
      var alt = v.getAttribute('data-mrt-alt');
      if (alt) principale.alt = alt;
    }
    $$('[data-mrt-vignette]').forEach(function (x) {
      x.setAttribute('aria-pressed', String(x === v));
    });
  }

  function deplacerGalerie(sens) {
    var vignettes = $$('[data-mrt-vignette]');
    if (!vignettes.length) return;
    var i = vignettes.findIndex(function (x) { return x.getAttribute('aria-pressed') === 'true'; });
    var suivante = (i + sens + vignettes.length) % vignettes.length;
    choisirVignette(vignettes[suivante]);
  }

  /* Sur mobile, on fait defiler la galerie en balayant l'image principale. */
  var departX = null, departY = null;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.mrt-produit-cadre')) return;
    departX = e.touches[0].clientX; departY = e.touches[0].clientY;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (departX === null) return;
    var dx = e.changedTouches[0].clientX - departX, dy = e.changedTouches[0].clientY - departY;
    departX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) deplacerGalerie(dx < 0 ? 1 : -1);
  }, { passive: true });

  /* ------------------------------------------------------------ interactions */

  document.addEventListener('click', function (e) {
    var el = e.target.closest(
      '[data-mrt-ajout],[data-mrt-plus],[data-mrt-moins],[data-mrt-ouvre-panier],[data-mrt-ferme-panier],[data-mrt-vignette],[data-mrt-galerie],[data-mrt-filtre],[data-mrt-burger],[data-mrt-ugc]'
    );
    if (!el) return;

    if (el.hasAttribute('data-mrt-ajout')) {
      e.preventDefault();
      ajouter(el.getAttribute('data-mrt-ajout'), el.getAttribute('data-mrt-quantite') || 1, el);
      return;
    }
    if (el.hasAttribute('data-mrt-plus') || el.hasAttribute('data-mrt-moins')) {
      var cle = el.getAttribute('data-mrt-plus') || el.getAttribute('data-mrt-moins');
      changerLigne(cle, el.getAttribute('data-mrt-qte'));
      return;
    }
    if (el.hasAttribute('data-mrt-ouvre-panier')) {
      e.preventDefault();
      ouvrirTiroir();
      if (!etatPanier) chargerPanier();
      return;
    }
    if (el.hasAttribute('data-mrt-ferme-panier')) { e.preventDefault(); fermerTiroir(); return; }

    if (el.hasAttribute('data-mrt-vignette')) { choisirVignette(el); return; }
    if (el.hasAttribute('data-mrt-galerie')) { deplacerGalerie(Number(el.getAttribute('data-mrt-galerie')) || 1); return; }

    if (el.hasAttribute('data-mrt-filtre')) {
      var f = el.getAttribute('data-mrt-filtre');
      $$('[data-mrt-filtre]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === el)); });
      $$('[data-mrt-tags]').forEach(function (c) {
        var tags = (c.getAttribute('data-mrt-tags') || '').split(' ');
        c.hidden = !(f === 'tous' || tags.indexOf(f) !== -1);
      });
      return;
    }

    if (el.hasAttribute('data-mrt-ugc')) {
      var piste = el.closest('.mrt-ugc-zone').querySelector('.mrt-ugc');
      var sens = Number(el.getAttribute('data-mrt-ugc')) || 1;
      var fin = piste.scrollWidth - piste.clientWidth - 4;
      /* En bout de bande, on repart de l'autre cote. */
      if (sens > 0 && piste.scrollLeft >= fin) piste.scrollTo({ left: 0, behavior: 'smooth' });
      else if (sens < 0 && piste.scrollLeft <= 4) piste.scrollTo({ left: piste.scrollWidth, behavior: 'smooth' });
      else piste.scrollBy({ left: sens * piste.clientWidth, behavior: 'smooth' });
      return;
    }

    if (el.hasAttribute('data-mrt-burger')) {
      var menu = $('.mrt-menu-mobile');
      if (menu) {
        var ouvert = menu.classList.toggle('ouvert');
        el.setAttribute('aria-expanded', String(ouvert));
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && tiroir && tiroir.classList.contains('ouvert')) fermerTiroir();
  });

  /* Les formulaires d'ajout produit passent par le tiroir plutot que de recharger. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-mrt-form-achat]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qte = form.querySelector('[name="quantity"]');
    if (!id) { form.submit(); return; }
    ajouter(id.value, qte ? qte.value : 1, form.querySelector('[type="submit"]'));
  });

  /* ------------------------------------------------------ texte sur une ligne */

  /* Reduit la taille d'un element [data-mrt-ajuste] jusqu'a ce qu'il tienne sur
     une ligne, sans descendre sous data-mrt-min (px). Au-dela, il reste tel quel. */
  function ajusterTout() {
    $$('[data-mrt-ajuste]').forEach(function (el) {
      el.style.fontSize = '';
      var min = Number(el.getAttribute('data-mrt-min')) || 11;
      var taille = parseFloat(getComputedStyle(el).fontSize);
      var garde = 40;
      el.style.whiteSpace = '';
      el.style.flexWrap = '';
      while (el.scrollWidth > el.clientWidth + 1 && taille > min && garde--) {
        taille -= 0.5;
        el.style.fontSize = taille + 'px';
      }
      /* Trop long meme au minimum : la rangee defile (data-mrt-defile),
         sinon le texte passe a la ligne plutot que d'etre coupe. */
      if (el.scrollWidth > el.clientWidth + 1) {
        if (el.hasAttribute('data-mrt-defile')) {
          el.style.overflowX = 'auto';
        } else {
          /* Deux lignes de toute facon : on reprend une taille confortable. */
          el.style.fontSize = el.getAttribute('data-mrt-repli') || '';
          el.style.whiteSpace = 'normal';
          el.style.flexWrap = 'wrap';
        }
      } else {
        el.style.overflowX = '';
      }
    });
  }
  var minuterie;
  window.addEventListener('resize', function () { clearTimeout(minuterie); minuterie = setTimeout(ajusterTout, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(ajusterTout);

  function demarrer() {
    ajusterTout();
    tiroir = $('.mrt-drawer');
    voile = $('.mrt-voile');
    if (tiroir) tiroir.setAttribute('aria-hidden', 'true');
    chargerPanier();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  document.addEventListener('shopify:section:load', function () {
    tiroir = $('.mrt-drawer');
    voile = $('.mrt-voile');
    rendre();
  });
})();
